<template>
  <div class="report_builder">
    <v-container>
      <v-form ref="form" v-model="valid">
        <h2 class="mb-2">
          {{ $store.state.customerName }} Index 作成画面 CreateIndex.vue
        </h2>
        <p>一覧表示する帳票を設定</p>
        <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
        <v-row>
          <!--{{ productForms.area[0].name }}-->
          <v-col cols="12" sm="9">
            <v-card outlined class="pa-6">
              <v-row justify="center">
                <v-col v-if="productForms.pageType != 8">
                  <v-btn @click="modalOpen(2)" color="primary" class="ma-4"
                    >検索フォームの追加</v-btn
                  >
                </v-col>
                <v-col v-if="productForms.pageType != 8">
                  <v-btn @click="modalOpen(3)" color="primary" class="ma-4"
                    >CSVダウンロードボタンの追加</v-btn
                  >
                </v-col>
              </v-row>
              <v-row justify="center" class="mt-4">
                <v-radio-group
                  label="新規作成ボタン"
                  v-model="productForms.area[0].create"
                  row
                >
                  <v-radio label="有" v-bind:value="true"></v-radio>
                  <v-radio label="無" v-bind:value="false"></v-radio>
                  <!--
                    <v-radio
                    v-if="this.productForms.pageType == 8"
                    label="本番環境時のみ新規作成"
                    v-bind:value="Strignproduct"
                  ></v-radio>
                  -->
                </v-radio-group>
              </v-row>
              <v-text-field
                v-model="productForms.area[0].path"
                element="ul"
                label="Path"
                placeholder="クリックすると移動するURL"
                background-color="white"
                outlined
                disabled
              ></v-text-field>
              <v-text-field
                v-model="productForms.area[0].list_pageID"
                element="ul"
                label="ページID"
                placeholder="一覧表示するページID"
                background-color="white"
                outlined
                :rules="[rules.numonly]"
              ></v-text-field>
              <v-row justify="center" class="mt-4">
                <v-btn @click="modalOpen(1)" color="primary"
                  >ヘッダー情報</v-btn
                >
              </v-row>
              <v-row justify="center" class="mt-4">
                <v-btn @click="saveForm()" color="primary">SAVE</v-btn>
              </v-row>
              <!--  ヘッダフォーム -->
              <v-dialog v-if="head_dialog" v-model="head_dialog">
                <index-form
                  v-on:clickSubmit="modalClose"
                  :headers="productForms.headers_t"
                  :rules="productForms.area[0].rules"
                  :name="productForms.area[0].name"
                  :pageType="productForms.pageType"
                  :pageID="productForms.area[0].list_pageID"
                ></index-form>
              </v-dialog>
              <!--  検索フォーム -->
              <v-dialog v-if="search_dialog" v-model="search_dialog">
                <search-form
                  v-on:clickSubmit="modalClose"
                  :searchs="productForms.searchs_t"
                  :page_id="Number(productForms.area[0].list_pageID)"
                ></search-form>
              </v-dialog>
              <!--  CSV読み込みフォーム -->
              <v-dialog v-if="csv_dialog" v-model="csv_dialog">
                <csv-form
                  v-on:clickSubmit="modalClose"
                  :value="csv_t"
                  :rule="rule_t"
                  :description="
                    productForms.area[productForms.area.length - 1].description
                  "
                  :enable="
                    productForms.area[productForms.area.length - 1].name ==
                      'csv' &&
                    productForms.area[productForms.area.length - 1].value !=
                      null
                      ? true
                      : false
                  "
                  :page_id="Number(productForms.area[0].list_pageID)"
                ></csv-form>
              </v-dialog>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import indexForm from "../../components/BuilderForm/ReportIndex/IndexForm";
import searchForm from "../../components/BuilderForm/ReportIndex/IndexSearchForm";
import csvForm from "../../components/BuilderForm/ReportIndex/IndexCsvForm";
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  components: {
    indexForm,
    searchForm,
    csvForm,
  },
  data() {
    return {
      head_dialog: false,
      search_dialog: false,
      csv_dialog: false,
      productForms: {
        pageType: null,
        pageID: null,
        area: [
          {
            type: 5,
            path: null,
            list_pageID: null,
            create: true,
            rules: "",
            headers: [
              [{ text: "日時", value: 0, align: "start", sortable: true }],
            ],
          },
        ],
        headers_t: [],
        searchs_t: [],
        delete_area: [],
      },
      csv_t: [],
      rule_t: [],
      //バリデーション
      valid: true,
      rules: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
      },
    };
  },
  async mounted() {
    //初期処理
    await this.getInit();
  },
  methods: {
    async getInit() {
      //初期処理
      this.isLoading = true;
      //page IDとcustomer IDとform情報を送信
      let data = {};
      data.customerID = this.$store.state.customerID;
      data.pageID = Number(this.$route.params.page_id);
      this.productForms.pageID = this.$route.params.page_id;
      this.$store.state.customerID = Number(this.$route.params.id);
      const response = await api.GetForm(data);

      if (response.data[0][0].ID != 0) {
        this.productForms.area = this.respose_convert(response.data[0]);
      }
      //ページごとの変更
      const path = this.$route.path.split("/");
      switch (path[path.length - 1]) {
        case "index_builder": //通常の一覧ページ
          this.productForms.pageType = 3;
          break;
        case "user_index_builder": //ユーザ情報一覧ページ
          this.productForms.pageType = 8;
          break;
        case "batch_approval": //一括承認
          this.productForms.pageType = 16;
          break;
        default:
      }
      //読み込み終了
      this.isLoading = false;
    },
    async saveForm() {
      if (!this.$refs.form.validate()) {
        return;
      }
      let data = {
        area: [this.productForms.area],
        pageID: this.productForms.pageID,
        delete_area: this.productForms.delete_area,
      };
      try {
        data.pageID = await api.RegForm(data, "");
        alert("保存完了");
        this.back();
      } catch (err) {
        alert("送信失敗");
        console.log(err);
      }
    },
    modalOpen: function(value) {
      switch (value) {
        case 1:
          //参照渡しの回避
          this.productForms.headers_t = JSON.parse(
            JSON.stringify(this.productForms.area[0].headers)
          );
          this.head_dialog = true;
          break;
        case 2:
          this.productForms.searchs_t = JSON.parse(
            JSON.stringify(this.productForms.area)
          );
          this.search_dialog = true;
          break;
        case 3:
          //末尾がCSVダウンロードボタンでない場合
          if (
            this.productForms.area[this.productForms.area.length - 1].name !=
              "csv" ||
            this.productForms.area[this.productForms.area.length - 1].value ==
              "" ||
            this.productForms.area[this.productForms.area.length - 1].value ==
              null
          ) {
            this.csv_t = [];
            this.rule_t = [];
          } else {
            this.csv_t = JSON.parse(
              this.productForms.area[this.productForms.area.length - 1].value
            );
            console.log(" this.csv_t", this.csv_t);
            if (this.csv_t.length > 0 && !("csvCol" in this.csv_t[0])) {
              this.csv_t.forEach((v) => {
                this.$set(v, "csvCol", 1);
              });
            }
            this.rule_t = [];
            if (
              this.productForms.area[this.productForms.area.length - 1].rule !=
              ""
            ) {
              this.rule_t = JSON.parse(
                this.productForms.area[this.productForms.area.length - 1].rule
              );
            }
          }
          this.csv_dialog = true;
          break;
      }
    },
    modalClose(param) {
      //headモーダル
      if (this.head_dialog) {
        this.productForms.area[0].headers = JSON.parse(
          JSON.stringify(param.headers)
        );
        this.productForms.area[0].rules = param.rules;
        this.productForms.area[0].name = param.name;
        this.productForms.headers_t = null;
        this.head_dialog = false;
      } else if (this.search_dialog) {
        //serachモーダル
        this.productForms.area = param.searchs;
        this.productForms.delete_area = param.delete_area;
        this.productForms.searchs_t = null;
        this.search_dialog = false;
      } else if (this.csv_dialog) {
        //CSVモーダル
        let tmp = {};
        tmp.form_id = this.productForms.area[
          this.productForms.area.length - 1
        ].form_id;
        tmp.name = "csv";
        tmp.type = 5;
        tmp.list_pageID = this.productForms.area[0].list_pageID;
        if (!param.enable) {
          tmp.value = null;
          tmp.rule = null;
          tmp.description = "";
        } else {
          //csvColが全て1(初期値)の時は保存しない(データ削減のため)
          let csvColFlag = false;
          param.value.forEach((v) => {
            if (v.csvCol != 1) {
              csvColFlag = true;
            }
          });
          if (csvColFlag == false) {
            param.value.forEach((v) => {
              this.$delete(v, "csvCol");
            });
          }

          tmp.value = JSON.stringify(param.value);
          tmp.rule = JSON.stringify(param.rule);
          tmp.description = param.description;
        }
        if (
          this.productForms.area[this.productForms.area.length - 1].name ==
          "csv"
        ) {
          this.productForms.area[this.productForms.area.length - 1] = tmp;
        } else {
          this.productForms.area.push(tmp);
        }
        this.csv_dialog = false;
      }
    },
    respose_convert: function(data) {
      let area = [];
      data.forEach((value, index) => {
        let tmp = {};
        tmp.form_id = value.ID;
        tmp.name = value.Name;
        tmp.type = 5; //value.Type;
        tmp.path = value.Label;
        tmp.list_pageID = value.Init;
        //ヘッダー
        if (index == 0) {
          tmp.headers = JSON.parse(value.Value);
          let arr = value.Rule.split(",");
          if (arr[0] == "true") {
            tmp.create = true;
          } else {
            tmp.create = false;
          }
          tmp.rules = arr.slice(1, arr.length).join(",");
          area.unshift(tmp); //先頭追加
        } else if (value.Name == "") {
          //検索フォーム
          const s = value.Value.split(",");
          tmp.value = s[0];
          tmp.target_id = s[1];
          tmp.cols = value.Cols;
          tmp.color = value.Rule;
          area.push(tmp);
        } else if (value.Name == "csv") {
          //CSVフォーム
          tmp.value = value.Value;
          tmp.description = value.Label;
          tmp.rule = value.Rule;
          area.push(tmp);
        }
      });
      return area;
    },
    back() {
      history.back();
    },
  },
};
</script>

<style lang="stylus">
.droparea {
  background: #eee;
  min-height: 30em;
  padding: 1em;
}

/* ボタンの横に×ボタンwの表示するための調整 */
.tmp {
  width: 95%;
  padding: 0.2em;
  background-color: white;
}
</style>
